import { render, staticRenderFns } from "./addCooperation.vue?vue&type=template&id=6cf04c9a&scoped=true"
import script from "./addCooperation.vue?vue&type=script&lang=js"
export * from "./addCooperation.vue?vue&type=script&lang=js"
import style0 from "./addCooperation.vue?vue&type=style&index=0&id=6cf04c9a&prod&lang=css"
import style1 from "./addCooperation.vue?vue&type=style&index=1&id=6cf04c9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf04c9a",
  null
  
)

export default component.exports